import React from "react";
import { SectionData, ComponentRenderProps } from "./index";

const OnPageLoadAction: React.FC<{ sectionData: SectionData; props: ComponentRenderProps }> = ({ sectionData, props }) => {
    React.useEffect(() => {
        const handler = () => {
            if (
                sectionData?.postLoadAction?.method &&
                typeof window !== "undefined" &&
                // @ts-ignore
                typeof (window as any)[sectionData.postLoadAction.method] === "function"
            ) {
                (window as any)[sectionData.postLoadAction.method](sectionData.inputObj, props);
            } else if (sectionData?.postLoadAction?.method) {
                console.warn(`OnPageLoadAction: Global function ${sectionData.postLoadAction.method} not found or not a function.`);
            }
        };
        handler();
    }, [sectionData, props]);
    return null;
};
export default OnPageLoadAction;
